import { useSyncExternalStore } from "react";

const cache = new Map<
    string,
    {
        subscribe: (cb: () => void) => () => void;
        getSnapshot: () => boolean;
    }
>();

const noopEntry = {
    subscribe: () => () => {},
    getSnapshot: () => false,
};

function getEntry(query: string) {
    if (
        typeof window === "undefined" ||
        typeof window.matchMedia !== "function"
    ) {
        return noopEntry;
    }
    let entry = cache.get(query);
    if (!entry) {
        let mql: MediaQueryList | null = null;

        function getMediaQueryList() {
            if (typeof window === "undefined") {
                return null;
            }

            if (!mql) {
                mql = window.matchMedia(query);
            }

            return mql;
        }

        entry = {
            subscribe: (cb: () => void) => {
                const mediaQueryList = getMediaQueryList();
                if (!mediaQueryList) {
                    return () => {};
                }

                mediaQueryList.addEventListener("change", cb);
                return () => mediaQueryList.removeEventListener("change", cb);
            },
            getSnapshot: () => getMediaQueryList()?.matches ?? false,
        };
        cache.set(query, entry);
    }
    return entry;
}

export function useMediaQuery(query: string): boolean {
    const { subscribe, getSnapshot } = getEntry(query);
    return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
